import { render } from "./detail.vue?vue&type=template&id=b7e2065a&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=b7e2065a&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7e2065a"],['__file',"src/views/customer/history/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b7e2065a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b7e2065a', __exports__)) {
    console.log('reload')
    api.reload('b7e2065a', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=b7e2065a&scoped=true", () => {
    console.log('re-render')
    api.rerender('b7e2065a', render)
  })

}


export default __exports__